import { NutritionVersionService } from "@omnia/shared/nutrition/version/service";
import { useAsyncValue } from "@omnia/shared/react/hooks";
import { IOmniaService, IOmniaSession } from "@omnia/types";
import { useMemo, useState } from "react";

const defaultStatus = {
    currentYear: 0,
    years: [],
    requestPending: false
}

export function useMigrationStatus(version: NutritionVersionService, session: IOmniaSession, fixedYear: number = 0) {

    const years = session.holding.CropYears
    const sessionYear = session.yearId
    const [year, setYear] = useState(fixedYear)

    let status = useAsyncValue(async () => {

        await version.ensureInit()

        const { firstYear, nextYear } = version

        const currentYear = nextYear || firstYear

        const availableYears: [number, string][] = fixedYear
            ? [[fixedYear, String(fixedYear)]]
            : years
                .filter(y => y.YearId <= currentYear)
                .map(y => y.YearId)
                .sort((a, b) => b - a)
                .map(y => [y, String(y)])

        if (!fixedYear) {
            setYear(availableYears.some(a => a[0] === sessionYear)
                ? sessionYear
                : currentYear
            )

        }

        return {
            currentYear,
            requestPending: nextYear && (nextYear < firstYear),
            years: availableYears
        }

    }, [version, years, sessionYear])

    status ??= defaultStatus

    const result = useMemo(() => {

        const { currentYear, requestPending, years } = status

        return {
            year,
            setYear,
            requestPending,
            currentYear,
            years
        }


    }, [status, year, setYear])

    return result

}